<template>
  <main class="pageSucess pt-5">
    <section
      class="bg-cover bg-center h-auto pt-20 px-0 object-fill text-white"
    >
      <div class="text-center pb-10">
        <h1 class="text-3xl font-bold py-5">Formulário de Inscrição:</h1>
        <router-link to="/" class="animate-hover-mouse"
          >Página Principal</router-link
        >
      </div>

      <Form class="mx-2" />
    </section>
  </main>
</template>

<script>
import Form from "../components/Form.vue";
export default {
  name: "FormView",
  components: {
    Form,
  },
};
</script>

<style scoped>
section {
  background-image: url("../assets/Grupo 1.png");
}

.animate-ping-caxias {
  animation: ping 2s cubic-bezier(0, 0, 0.2, 1) infinite;
  margin: 0 auto;
}

@keyframes ping {
  75%,
  100% {
    transform: scale(1.2);
    opacity: 0;
  }
}

.border-white-f2 {
  border-color: #f2f2f2;
}

.animate-hover-mouse {
  font-size: 100%;
  transition: all 0.3s;
  border: 2px solid #f2f2f2;
  padding: 8px 15px;
  margin: 10px;
}

.animate-hover-mouse:hover {
  border: 2px solid #f2f2f2;
  border-radius: 30px;
}
</style>
